import { useParams } from 'react-router-dom'

import { useW2MasterGetApi } from '@/common/api/modules/master'
import { MasterType } from '@/common/model/master/w2Master'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import MasterEditPage from '@/components/container/page/site/master/MasterEditPage'

interface Props {
  masterType: MasterType
}

const MasterUpdatePage = ({ masterType }: Props) => {
  const { siteId, id } = useParams()

  const { data, error, mutate } = useW2MasterGetApi({
    site_id: Number(siteId),
    master_type: masterType,
    record_id: Number(id)
  })

  return (
    <DetailPageLoader error={error} data={data} small>
      <MasterEditPage masterType={masterType} master={data} onRefetch={mutate} />
    </DetailPageLoader>
  )
}

export default MasterUpdatePage
